import api from "./";

//retorna apenas os da empresa solicitada
export const almoxarifadosByEmpresaId = async (empresaId) => {
    try {
        const { data } = await api.post("/almoxarifado/almoxarifadosByEmpresaId", {
            empresaId,
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
